import * as React from 'react';

export const PlaceholderRearRightV2 = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		id="rear-right-placeholder"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 797.9 499.4"
		{...props}
	>
		<path
			id="rear-right-placeholder-original"
			fill="currentColor"
			d="M0 0h797.9v499.4H0z"
			data-name="Rechteck 1"
			opacity=".2"
		/>
		<g id="rear-right-placeholder-original" fill="currentColor" data-name="Gruppe 6" opacity=".8">
			<path
				d="M736.2 375.5a9936 9936 0 01-262.4 62.7c-69.4 15.6-119.1 17-176.4 17S68.3 439.8 42.3 435.4s25.6-24.6 94-31c5.7-.5 13-1.3 21.7-2.3l1.8-.2a18.8 18.8 0 009.4 2.6l41 1.5h1.3c7.9 0 15.2-5 21-13.3a.2.2 0 01.2-.2c53.6-7.2 117.7-16.3 170.3-23.9a.9.9 0 00.1.5c3.5 29.1 15.2 50.4 29.1 50.4l37.5 1.6 1.2.1c15.9 0 29-26.1 31-60l-.1 2.1 24.9-3.9 19.2-2.9 80.8 5.9a39.5 39.5 0 002.5 4.6c3.1 4.8 6.8 7.5 10.7 7.5l25.7 1.2h.7c3.4 0 6.5-1.9 9.4-5.2a40 40 0 003-4.3c34.5 2.6 61.3 4.6 64.2 5 1.6.2 3.6 1.5-6.7 4.3z"
				data-name="Pfad 1"
				opacity=".1"
			/>
			<path
				d="M675.3 374.4a8374.2 8374.2 0 01-213 50.9c-56.3 12.6-96.7 13.8-143.2 13.8S123.7 428.6 102.6 425c-17.2-2.9 13.4-15.6 55.3-23l1.7-.3.1.1a18.8 18.8 0 009.4 2.6l41 1.5h1.3c7.9 0 15.2-5 21-13.3A13624 13624 0 00402.9 369c3.5 29.1 15.2 50.4 29.1 50.4l37.5 1.6 1.2.1c15.9 0 29-26.1 31-60l-.1 2.1 24.9-3.9 102.5 7.5c3.1 4.8 6.8 7.5 10.7 7.5l25.7 1.2h.7c3.4 0 6.5-1.9 9.4-5.2l5.1.5c1.5.3 3.1 1.4-5.3 3.6z"
				data-name="Pfad 2"
				opacity=".7"
			/>
			<path
				d="M663.7 317.6c-1.2 0-2.2 2.5-2.2 5.5v.5a10.9 10.9 0 00.6 3.4l-.1.4.2-.1 3.4-1.6a10.1 10.1 0 00.2-2.5c.1-3.1-.9-5.6-2.1-5.6z"
				data-name="Pfad 3"
			/>
			<g data-name="Gruppe 1">
				<path
					d="M663.7 317.6c-1.2 0-2.2 2.5-2.2 5.5v.5a10.9 10.9 0 00.6 3.4l-.1.4.2-.1c.4.9.9 1.4 1.4 1.4.8 0 1.6-1.2 1.9-3a10.1 10.1 0 00.2-2.5c.2-3.1-.8-5.6-2-5.6z"
					data-name="Pfad 4"
				/>
				<path
					d="M663.7 317.6c-1.2 0-2.2 2.5-2.2 5.5v.5a10.9 10.9 0 00.6 3.4l-.1.4.2-.1c.4.9.9 1.4 1.4 1.4.8 0 1.6-1.2 1.9-3a10.1 10.1 0 00.2-2.5c.2-3.1-.8-5.6-2-5.6z"
					data-name="Pfad 5"
				/>
				<path
					d="M663.7 317.6c-1.2 0-2.2 2.5-2.2 5.5v.5a10.9 10.9 0 00.6 3.4l-.1.4.2-.1c.4.9.9 1.4 1.4 1.4.8 0 1.6-1.2 1.9-3a10.1 10.1 0 00.2-2.5c.2-3.1-.8-5.6-2-5.6z"
					data-name="Pfad 6"
				/>
				<path
					d="M665.9 323.2a18 18 0 01-.2 2.5c-.4 1.8-1.1 3-1.9 3-.6 0-1.1-.5-1.4-1.4l-.2.1.1-.4a10.9 10.9 0 01-.6-3.4v-.5c0-3.1 1-5.5 2.2-5.5 1 0 2 2.5 2 5.6z"
					data-name="Pfad 7"
				/>
				<path
					d="M665.9 323.2a18 18 0 01-.2 2.5c-.4 1.8-1.1 3-1.9 3-.6 0-1.1-.5-1.4-1.4l-.2.1.1-.4.4-2.5-1-.8v-.5c0-3.1 1-5.5 2.2-5.5 1-.1 2 2.4 2 5.5z"
					data-name="Pfad 8"
				/>
				<path
					d="M665.9 323.2a18 18 0 01-.2 2.5c-.4 1.8-1.1 3-1.9 3-.6 0-1.1-.5-1.4-1.4l-.2.1.1-.4a10.9 10.9 0 01-.6-3.4v-.5c0-3.1 1-5.5 2.2-5.5 1 0 2 2.5 2 5.6z"
					data-name="Pfad 9"
				/>
				<path
					d="M665.9 323.2a18 18 0 01-.2 2.5c-.4 1.8-1.1 3-1.9 3-.6 0-1.1-.5-1.4-1.4l-.1-.3a10.9 10.9 0 01-.6-3.4v-.5c0-3.1 1-5.5 2.2-5.5 1 0 2 2.5 2 5.6z"
					data-name="Pfad 10"
				/>
			</g>
			<path
				d="M638.8 240.4a108.5 108.5 0 00-1.5 13.5l-.3 3.9a2977.5 2977.5 0 01-8.1 71.4v7.2l-.1.2-.1.2-3.3 6.2-.7 1.4-2.6 4.8-.1.2h-.6l-.5-.2.8-1.5 1.7-3.2.8-1.4 3.3-6.2.4-.7V329a2954 2954 0 008.4-75.2c.7-9 1.4-12.7 1.5-13.5l-7.6-21.1.8-.8 7.8 21.7v.3z"
				data-name="Pfad 11"
				opacity=".8"
			/>
			<path
				d="M687.9 315l.1-12.1s-4.5-38.2-19.8-40.5c-8-1.2-13.8 2.4-18 8.3a25.5 25.5 0 00-2.4 3.9c-4 7.5-6.1 17.3-7.4 25.7l-.5 3.3a145.4 145.4 0 01-7.5 32.8v-.1l-3.7.4.1-.2a.3.3 0 01.1-.2v-7.2a2877 2877 0 008.1-71.4l.3-3.9c.8-9.9 1.5-13.4 1.5-13.5v-.3l-7.8-21.7 2.2-2.3 1.7 2.2s25.2 9.2 35.7 18.5c4.9 4.4 8 7.8 10.2 11.2 2.5 3.8 3.8 7.6 5.1 13.1 7.1 27.8 6 39.3 2 54z"
				data-name="Pfad 12"
				opacity=".6"
			/>
			<path
				d="M661.5 206.5a62.8 62.8 0 01-19.9 5.8l.6-.1 4.1-.8a4.3 4.3 0 011.1-.2l2.5-.6 1.1-.3 1.6-.4h.2l1.4-.4 1.6-.5a1.9 1.9 0 01.7-.2 15.6 15.6 0 004.1-2c5.3-3.9-2.4-9.6-5.9-12-3.4-2.4-18.1-2.8-26.1-2.9a3.8 3.8 0 00-2.9 1.5 3.3 3.3 0 00-.3 3.2l6.1 15-1.2 1.1-2.4 2.1-.1.1-2 1.6-3.1 2.4c1.4 3.7 5.7 2.7 5.7 2.7l1.8-2 7.6 21.1c-.1.8-.8 4.5-1.5 13.5l-.3 3.8c-.2 3.2-.7 8.5-1.4 14.7-2.3 22-6.7 56.2-6.7 56.7v7.2l-.4.7-7.4.9c-11.4 1.3-29.2 3.2-46.3 4.5 1-4.2.7-6.2.5-7l-.2-.4-.2-.2s-2.4-1.3-4.1-5.8l-.2-.5a49 49 0 01-.6-10.7c.1-6 .4-13.3.8-20.2l.5-9.8c.3-8.3-1.1-23.6-2.4-35.6a31 31 0 00-.4-3.2l-1.7-13.8.2-6.5.2-6.3v-.2l-4.5-15.9-2.8-10 64.4 19.5a15.6 15.6 0 012.3-3.6l.2-.3 2.1-2.3 1.1-1-4.4-11.4a4.4 4.4 0 01.5-4.3 4.2 4.2 0 013.8-1.9c8.9.2 23.5.9 26.8 3.2 3.3 1.8 11.1 8 5.8 12z"
				data-name="Pfad 13"
				opacity=".6"
			/>
			<path
				d="M572.7 342.4c-27.9 2.1-63.3 2-64.1 2a26.4 26.4 0 00.2-2.9c.5-9.8 4.6-59.5-20.3-76.5l.5-.2-5-15.1-3.8-11.5-4.8-14.7-4.3-13.1-.5-4.8-.8-7.7v-.3l-5.8-18.2-4-12.7c17 4.6 59.3 17.2 97.4 28.7l.1.3 2.7 9.8 4.6 16.2.1.2-.1 6.1-.2 6.8 1.7 13.4.4 3.5c1.3 12 2.8 27.4 2.4 35.6l-.5 9.8c-.3 7.1-.7 14.4-.8 20.3 0 4.8.1 8.6.6 10.8a3 3 0 01.2.8 13 13 0 004.1 6.1l.3.2c.4.6.9 2.5-.3 7.1z"
				data-name="Pfad 14"
				opacity=".6"
			/>
			<path
				d="M627.8 209.2a25 25 0 00-2.1 2.3c-10.3-13.5-36.1-46.7-54-63.1a131 131 0 00-42.3-24.7l-.2-.4-.5.2a156 156 0 00-25.6-7.2 92.6 92.6 0 00-17.9-1.9 56.9 56.9 0 00-11.8 1.2 28.6 28.6 0 00-2.8.7 48.7 48.7 0 00-7.8 2.8h-.5v.3c-7.7 3.5-15.3 9-24 16.8l-3.6 3.2-1.9 1.7c-12.6 11.7-4.6 17.4 25.2 25.3a3 3 0 00.9.2v.3l3.9 12.4 5.9 18.5.1.2.8 7.5.5 5.2v.1l4.1 12.5 4.8 14.6 3.9 11.8 4.9 14.9a32.4 32.4 0 00-15.4-5.1c-16.5-1.4-27.2 9.3-34.4 22.9l-.6 1.1a118 118 0 00-5.4 12.7 219.1 219.1 0 00-6.8 25.2 229.2 229.2 0 01-7.7 28.6l-15.7-.6c-18.7-.8-47.8-2.5-50-4.8a133 133 0 00-23.1-19.7l-1.6-.9a92 92 0 00-31.8-5.5l-20-.7-32.8-1.1-7.8-.3-3-.1-17-.5-4.1-.1a20.9 20.9 0 01-2.5-.1l-9.3-.3a14.8 14.8 0 01-2.1-.1l-4-.1-12.2-.4-11.5-.3-29.5-.8c-11.5-.3-19.7-.4-22.3-.2-4 .2-6.6 2.6-8.2 6.1-3.3 7-2.7 18.2-2.6 22.3a34 34 0 01-5.7-12.6c-4.8-19.4-11.9-45.7-6.6-55.2a51.7 51.7 0 002.8-7.1v-.1a871 871 0 0013.9-51.1l6.4-1.2c-2.8 16.5-6 35.9-6.3 42.3-.6 11.5-.1 19.8 11.5 20.6 11 .8 40.9 1.4 76.4 1.9l10.1.1h4.7c25.1.3 51.9.5 76 .6l30.9.1h.4c17.7 0 20.2-10.1 21.4-21.4a2095.9 2095.9 0 002.8-46c30.8 3.7 64.3 8.3 77.7 12l13.4 20.9 1.8 2.9 11.3 18 .9-.5-11-17.4c-5.1-8-10.4-15.6-15.5-23.5l-1-1.5a.3.3 0 01-.1-.2c-5.2-8.1-9.5-14.8-11-16.8a47.4 47.4 0 00-34.2-18.7c-9.6-.8-20.1-1.4-30.9-1.9v-.7l-5.2-11.8 14.8-15.8-.4-.3 7.3-5.7 2.6-2.1 6-4.9 3-2.4 2.2-1.8.1-.1c27.2-21 53.1-37 73.5-41.6h.4c44.5 3.1 96 25.4 120.4 47.4 18.7 15.8 44.3 47.4 56.6 63z"
				data-name="Pfad 15"
				opacity=".6"
			/>
			<path
				d="M119.1 177.1l2.9 11.3a5.4 5.4 0 00-.1.8l-4.5.2-5.2-11.4.2-.1.2-.1.1-.1 18.1-12.1-11.5 11a.4.4 0 00-.2.5z"
				data-name="Pfad 16"
				opacity=".6"
			/>
			<path
				d="M340.8 173.3l5.3 12v.4c-45-2-93.7-2-93.7-2l31.5 22.1s-40.8-4.2-73.5-3.2-55.1 4.9-55.1 4.9l27.6-21.8s-24.2.8-47.5 2.6l-12.6.8a2.6 2.6 0 00.1-.7v-.2l-2.8-11.2 13.8-13.2-.3-.4c.7 0 35.8-2.3 83.2-4.1l24.9-.8 11.8-.4 4.5-.1 11.1-.3 4.6-.1 10.7-.2 4.5-.1 10.4-.2h4.2l6.6-.1h4l6.4-.1h35.1l-14.7 15.7a.6.6 0 00-.1.7z"
				data-name="Pfad 17"
				opacity=".6"
			/>
			<path
				d="M344.8 212.5c-.6 11.1-1.2 23.5-1.9 33.2-.3 5.3-.7 9.8-1 12.8-1.2 11.2-3.5 20.5-20.4 20.5h-.4l-30.5-.1a4780 4780 0 01-167.9-2.6c-9.8-.7-11.2-6.6-10.6-19.5.3-6.4 3.5-26 6.3-42.5l36.9-6.7 8.9 28.5a4.6 4.6 0 004.4 3.2h88.7a4.7 4.7 0 003.8-1.9l22.8-31.5c0-.1 28.9 2.8 60.9 6.6z"
				data-name="Pfad 18"
				opacity=".6"
			/>
			<path
				d="M462 124.7l-1.2 16.2c-6.5-.3-13.3-.4-20.6-.2a115 115 0 0121.8-16z"
				data-name="Pfad 19"
				opacity=".4"
			/>
			<path
				d="M542.8 159.4l-5.9-2.3a229 229 0 00-75-16.1l1.2-16.8a47.9 47.9 0 0122.2-5.1 93.8 93.8 0 0117 1.8 164 164 0 0128.3 8.3z"
				data-name="Pfad 20"
				opacity=".4"
			/>
			<path
				d="M606.2 194.4a262.3 262.3 0 00-62.1-34.5l-12.3-30.1a123 123 0 0136.6 22.1c11.3 10.4 26 27.8 37.8 42.5z"
				data-name="Pfad 21"
				opacity=".4"
			/>
			<path
				d="M530.5 129.3a164 164 0 00-28.3-8.3 93.8 93.8 0 00-17-1.8 47.2 47.2 0 00-22.2 5.1l.4-5.1h-.5a45.5 45.5 0 017.8-2.8l2.8-.7a55.5 55.5 0 0111.8-1.2 101.2 101.2 0 0117.9 1.9 161.8 161.8 0 0125.6 7.2l-.5.2z"
				data-name="Pfad 22"
			/>
			<g data-name="Gruppe 2">
				<path
					d="M462 124.7a112 112 0 00-21.8 16.1c7.3-.2 14.2-.1 20.6.2l-1.5 20.8-.3 4.8a3 3 0 00-.9-.2c-29.9-7.9-37.8-13.6-25.2-25.3a15.4 15.4 0 011.9-1.7l3.6-3.2c8.8-7.8 16.4-13.3 24-16.8z"
					data-name="Pfad 23"
				/>
				<path
					d="M557.5 195.5c-38.1-11.5-80.4-24-97.4-28.7l-.1-.2.3-4.7 1.5-21a229 229 0 0175 16.1l5.9 2.3 12.5 30.6z"
					data-name="Pfad 24"
				/>
				<path
					d="M625.6 211.5l-.2.3a13.8 13.8 0 00-2.3 3.6l-64.4-19.5-.1-.4-2.2-5.3-12.3-30.3c28.4 11.4 48.5 24 62.1 34.5a433.6 433.6 0 00-37.8-42.5 123.8 123.8 0 00-36.6-22.1l-2.5-6.1a131 131 0 0142.3 24.7c17.9 16.4 43.7 49.6 54 63.1z"
					data-name="Pfad 25"
				/>
			</g>
			<g data-name="Gruppe 3">
				<path
					d="M346.1 185.8l-1.2 26.7c-32-3.8-60.9-6.7-60.9-6.7l-31.5-22.1c-.1 0 48.6 0 93.6 2.1z"
					data-name="Pfad 26"
					opacity=".8"
				/>
				<path
					d="M424.3 224.9l-.7-.2h-.1c-13.3-3.8-46.8-8.3-77.7-12a2553 2553 0 001.3-26.8c10.8.5 21.3 1.1 30.9 1.9a47.6 47.6 0 0134.2 18.7c1.5 2.1 5.8 8.7 11 16.8a.3.3 0 01.1.2 7.1 7.1 0 011 1.4z"
					data-name="Pfad 27"
					opacity=".8"
				/>
				<path
					d="M183 185.7l-27.6 21.8-36.9 6.7 4.4-25.1 12.6-.8c23.3-1.8 47.5-2.6 47.5-2.6z"
					data-name="Pfad 28"
					opacity=".8"
				/>
				<path
					d="M121.9 189.2l-4.5 25.2-6.4 1.2.5-2 .4-1.7.3-1.4.3-1.2.3-1.1.2-1 .4-1.5.3-1.1 1.1-4.6a8.3 8.3 0 01.4-1.5l.2-.9.3-1.1.3-1.3.1-.6.2-.8.2-.8.1-.4.2-.8.1-.5.1-.5.1-.5.1-.5.1-.3 4.6-.3z"
					data-name="Pfad 29"
					opacity=".8"
				/>
				<path d="M113.5 205.7l2-8.1-2 8.1z" data-name="Pfad 30" />
			</g>
			<path
				d="M451 98.3h-.2l-7.3-.5-2.1-.1-11.9-.7-3.1-.2-6.6-.4-3.3-.2-3.4-.2-2.3-.1-3.7-.2-3.8-.2-9.8-.4-5.9-.2-6-.2c-8-.2-15.9-.4-23.4-.4a930 930 0 00-87.7 5.2c-32.2 3.7-68.6 24.1-123.1 55.8h-.1l-11.7 6.8-2.1 1.2c.7 0 35.8-2.3 83.2-4.1l24.9-.8 11.8-.4 4.5-.1 11.1-.3 4.6-.1 10.7-.2 4.5-.1 10.4-.2h4.2l6.6-.1h4l6.4-.1h35.1l.3-.3.4.3c7.1-5.9 14.1-11.6 21.1-17l.1-.1C404.7 119 430.6 103 451 98.3zm-268.2 42.4l10.8-6a331 331 0 0155.5-25.4 120.3 120.3 0 0122-4.9c19.6-2.2 43.6-3.9 71.5-4.9 4.6-.2 9.9-.2 15.7-.2 10.7 0 22.4.3 33.8.7-56.6 3.9-140.6 14.9-209.3 40.7z"
				data-name="Pfad 31"
			/>
			<path
				d="M392.1 99.9c-56.6 4-140.5 15-209.2 40.7l10.8-6a331 331 0 0155.5-25.4 120.3 120.3 0 0122-4.9c19.6-2.2 43.6-3.9 71.5-4.9 4.6-.2 9.9-.2 15.7-.2 10.6 0 22.3.3 33.7.7z"
				data-name="Pfad 32"
				opacity=".4"
			/>
			<path
				d="M283.9 205.8l-22.8 31.5a4.7 4.7 0 01-3.8 1.9h-88.7a4.6 4.6 0 01-4.4-3.2l-8.9-28.5 18.3 4.7 86.9-1.6z"
				data-name="Pfad 33"
				opacity=".8"
			/>
			<path
				d="M283.9 205.8l-23.3 4.8-86.9 1.6-18.3-4.7s22.3-3.9 55.1-4.9c32.6-1 73.4 3.2 73.4 3.2z"
				data-name="Pfad 34"
				opacity=".4"
			/>
			<g data-name="Gruppe 4">
				<path
					d="M627.5 336.9l-3.3 6.2-.8 1.4-1.7 3.2-.8 1.5.5.2c-6.7.1-20-.2-47.8 3.1l-3 .4a12.7 12.7 0 00.4-1.5 9.3 9.3 0 01.4-1.3l1.7-5.6.6-2.2c17.1-1.3 34.9-3.2 46.3-4.5l7.5-.9z"
					data-name="Pfad 35"
				/>
				<path
					d="M688 302.9s-4.5-38.2-19.8-40.5c-8-1.2-13.8 2.4-18 8.3a25.5 25.5 0 00-2.4 3.9c-4 7.5-6.1 17.3-7.4 25.7l-.5 3.3a145.4 145.4 0 01-7.5 32.8v-.1l-3.7.4-3.3 6.2-.7 1.4-2.6 4.8v.2a72 72 0 004.4 12.9 39.5 39.5 0 002.5 4.6c3.1 4.8 6.8 7.5 10.7 7.5l25.7 1.2h.7c3.4 0 6.5-1.9 9.4-5.2a40 40 0 003-4.3 90.8 90.8 0 009.1-43l-.2-8 .3-.2zm-20.3 60.5a5.9 5.9 0 01-1.4-.2c-3.7-.8-7-4.8-9.5-10.9a71 71 0 01-4.5-20.2 87 87 0 01-.4-8.9c0-11.7 2-22.3 5.1-29.6 2.4-5.6 5.5-9.3 8.9-10.3a5.7 5.7 0 011.8-.3c7.9 0 14.5 14.8 15.6 34.2l.2 6c0 22.2-7 40.2-15.8 40.2z"
					data-name="Pfad 36"
				/>
				<path
					d="M683.4 317.1c-1.1-19.3-7.7-34.2-15.6-34.2a5.7 5.7 0 00-1.8.3c-3.4 1-6.5 4.7-8.9 10.3a77.1 77.1 0 00-5.1 29.6 85.7 85.7 0 00.4 8.9 71 71 0 004.5 20.2c2.5 6.1 5.8 10.1 9.5 10.9a7.8 7.8 0 001.4.2c8.7 0 15.8-18 15.8-40.2l-.2-6zm-3.1-11l-11.5 9.5a11.3 11.3 0 00-1.3-2.7l2.2-25.6c4.6 1.4 8.5 8.6 10.6 18.8zm-18.8 17.6v-.5c0-3.1 1-5.5 2.2-5.5s2.2 2.5 2.2 5.5a18 18 0 01-.2 2.5c-.4 1.8-1.1 3-1.9 3-.6 0-1.1-.5-1.4-1.4l-.2.1.1-.4a7 7 0 01-.8-3.3zm-3.4-25.8c2-5.3 4.5-9 7.4-10.4l-2.1 25.1a8.1 8.1 0 00-1.4 2.8l-1.7-1.4-5.1-4.3a53.6 53.6 0 012.9-11.8zm-.2 50a64.7 64.7 0 01-3.4-16.9c-.2-2.5-.3-5.2-.3-7.9a46 46 0 01.2-5.3l6.3 5 .3.2v.1a22.5 22.5 0 00.4 4.6l.4 2-3.2 19.6a3.7 3.7 0 01-.7-1.4zm10.2 11.5a5.7 5.7 0 01-1.8-.3 10.6 10.6 0 01-5.1-4.5l3.5-20a2.4 2.4 0 00.8.2 1 1 0 00.7-.2 3.8 3.8 0 001.3-1l9.5 17.5c-2.5 5.2-5.6 8.3-8.9 8.3zm10.9-13.9l-9.5-17.5a28.7 28.7 0 00.4-4.4v-.9l11.5-9.6.4 4.8.1 5.3a74 74 0 01-2.9 22.3z"
					data-name="Pfad 37"
					opacity=".8"
				/>
				<path
					d="M661.7 329.8l-3.2 19.6-.6-1.5a64.7 64.7 0 01-3.4-16.9c-.2-2.5-.3-5.2-.3-7.9a46 46 0 01.2-5.3l6.3 5 .3.2v.1a22.5 22.5 0 00.4 4.6 4.7 4.7 0 00.3 2.1z"
					data-name="Pfad 38"
				/>
				<path
					d="M676.9 351.1c-2.4 5.2-5.5 8.3-8.9 8.3a5.7 5.7 0 01-1.8-.3 10.6 10.6 0 01-5.1-4.5l3.5-20a2.4 2.4 0 00.8.2 1 1 0 00.7-.2 3.8 3.8 0 001.3-1z"
					data-name="Pfad 39"
				/>
				<path
					d="M682 323.2a77.1 77.1 0 01-3 22.3l-9.5-17.5a28.7 28.7 0 00.4-4.4v-.9l11.5-9.6.4 4.8.2 5.3z"
					data-name="Pfad 40"
				/>
				<path
					d="M680.3 306.1l-11.5 9.5a11.3 11.3 0 00-1.3-2.7l2.2-25.6c4.6 1.4 8.5 8.6 10.6 18.8z"
					data-name="Pfad 41"
				/>
				<path
					d="M665.5 287.6l-2.1 25.1a8.1 8.1 0 00-1.4 2.8l-1.7-1.4-5.1-4.3a59.7 59.7 0 013-11.8c1.8-5.3 4.4-9 7.3-10.4z"
					data-name="Pfad 42"
				/>
				<path d="M622.2 349.5h-.2l.1-.2.1.2z" data-name="Pfad 43" />
			</g>
			<g data-name="Gruppe 5">
				<path
					d="M450.8 265.8l-.9.5-11.3-18-1.8-2.9-13.4-20.9h.1l.7.2c5.1 8 10.5 15.5 15.5 23.5l11.1 17.6z"
					data-name="Pfad 44"
					opacity=".8"
				/>
				<path
					d="M347 185.1v.7a2553 2553 0 01-4.1 72.8c-1.2 11.3-3.7 21.4-21.4 21.4h-.4l-30.9-.1c-24.2-.1-51-.3-76-.6h-4.7l-10.1-.1c-35.4-.5-65.4-1.1-76.4-1.9-11.6-.8-12.1-9-11.5-20.6a1206.2 1206.2 0 0110.8-67.5 3.2 3.2 0 00.1-.8l-2.9-11.3a.7.7 0 01.1-.5l11.5-11 2.8-2 .3.4-13.8 13.2 2.8 11.2v.2a3.2 3.2 0 01-.1.7 1557.2 1557.2 0 00-10.7 67.6c-.6 13 .7 18.9 10.6 19.5a4780 4780 0 00167.9 2.6l30.5.1h.4c16.9 0 19.2-9.3 20.4-20.5l1-12.8a4603.7 4603.7 0 003.1-59.9v-.4l-5.3-12a.4.4 0 01.1-.5l14.7-15.7h.7l.4.3-14.8 15.8z"
					data-name="Pfad 45"
					opacity=".8"
				/>
				<path d="M133.6 163.6l-2.8 2 2.5-2.3z" data-name="Pfad 46" opacity=".4" />
				<path d="M356.2 157.1h-.7l.3-.3z" data-name="Pfad 47" opacity=".4" />
				<path
					d="M489.1 264.8l-.5.2-.7-.5-4.9-14.9-3.9-11.8-4.8-14.6-4.1-12.5v-.1l-.5-5.2-.8-7.5-.1-.2-5.9-18.5-3.9-12.4v-.3l.3-4.8 1.5-20.8 1.2-16.2.4-5.5a1.7 1.7 0 01.5-.2h.5l-.4 5.1-1.2 16.8-1.5 21-.3 4.7.1.2 4 12.7 5.8 18.2v.3l.8 7.7.5 4.8 4.3 13.1 4.8 14.7 3.8 11.5z"
					data-name="Pfad 48"
					opacity=".8"
				/>
				<path d="M462.9 119l-.5.2v-.3z" data-name="Pfad 49" opacity=".4" />
				<path d="M488.6 264.9l-.5.2-.2-.6a4.3 4.3 0 01.7.4z" data-name="Pfad 50" opacity=".4" />
				<path d="M622 349.5l-.1.2-.4-.2z" data-name="Pfad 51" opacity=".4" />
				<path d="M529.3 123.7a1.4 1.4 0 00-.6-.2l.5-.2z" data-name="Pfad 52" opacity=".4" />
				<path
					d="M573.8 342.3l-.6 2.2-1.7 5.6a9.3 9.3 0 00-.4 1.3 11.7 11.7 0 00-.4 1.5.7.7 0 00-.5.1l-.5-.1a13.3 13.3 0 00.3-1.3l.4-1.3 1.8-6.1a18 18 0 00.5-1.9c1.1-4.5.7-6.4.5-6.9l-.3-.2c-.9-.6-2.7-2.3-4.1-6.1a1.9 1.9 0 01-.2-.8 51 51 0 01-.6-10.8c0-5.9.4-13.2.8-20.3l.5-9.8c.3-8.2-1.1-23.6-2.4-35.6l-.4-3.5-1.7-13.4.2-6.8.1-6.1-.1-.2-4.6-16.2-2.7-9.8-.1-.3-2.4-5.6-12.5-30.5-12.3-30.1-2.3-5.6.5-.2a1.4 1.4 0 00.6.2l2.5 6.1 12.3 30.1 12.4 30.3 2.2 5.3.1.4 2.8 10 4.5 15.9v.2l-.2 6.3-.2 6.5 1.7 13.8.4 3.2c1.3 12 2.8 27.3 2.4 35.6l-.5 9.8c-.3 6.9-.7 14.3-.8 20.2 0 4.8.1 8.7.6 10.7a.8.8 0 00.2.5c1.7 4.5 4.1 5.8 4.1 5.8a.2.2 0 01.2.2l.2.4c.4 1 .7 3.1-.3 7.3z"
					data-name="Pfad 53"
					opacity=".8"
				/>
				<path d="M570.7 352.9v.2l-.5-.1a4.3 4.3 0 01.5-.1z" data-name="Pfad 54" opacity=".4" />
			</g>
			<path
				d="M508.7 344.4a26.4 26.4 0 00.2-2.9c.5-9.8 4.6-59.5-20.3-76.5l-.5.2-.2-.6a32.4 32.4 0 00-15.4-5.1c-16.5-1.4-27.2 9.3-34.4 22.9l-.6 1.1a118 118 0 00-5.4 12.7 219.1 219.1 0 00-6.8 25.2 229.2 229.2 0 01-7.7 28.6l-15.7-.6c-18.7-.8-47.8-2.5-50-4.8a133 133 0 00-23.1-19.7l-1.6-.9a92 92 0 00-31.8-5.5l-20-.7-32.8-1.1-7.8-.3-3-.1-17-.5-4.1-.1a20.9 20.9 0 01-2.5-.1l-9.3-.3a14.8 14.8 0 01-2.1-.1l-4-.1-12.2-.4-11.5-.3-29.5-.8c-11.5-.3-19.7-.4-22.3-.2-4 .2-6.6 2.6-8.2 6.1-3.3 7-2.7 18.2-2.6 22.3v1c0 2.9 6.9 7.9 15.2 11.3l1 .4c2.1.8 4.3 1.5 6.5 2.1l1.1.3 3.1.6 3.6.5c2.9 21 11.5 37.7 22.4 44l.1.1a18.8 18.8 0 009.4 2.6l41 1.5h1.3c7.9 0 15.2-5 21-13.3a.2.2 0 01.2-.2c4.8-7 8.6-16.4 10.8-27.1l60.8 2.8c7.2.3 17.8.3 29.6.2h2.4l11.4-.2h6.7l3.4-.1 3.9-.1 3.6-.1h3.6c6.5 0 12.8-.2 18.5-.5h1a17.7 17.7 0 002.3-.1l8.2-.3h4l.2 1.8a.9.9 0 00.1.5c3.5 29.1 15.2 50.4 29.1 50.4l37.5 1.6 1.2.1c15.9 0 29-26.1 31-60l-.1 2.1 24.9-3.9 19.2-2.9 24.3-3.5-.5-.1a13.3 13.3 0 00.3-1.3l.4-1.3 1.8-6.1a18 18 0 00.5-1.9c-27.7 1.7-63 1.7-63.8 1.7zm-12.9 10.7a14.8 14.8 0 01-.1 2.1l-.1 2.4c-1.6 25.7-11.2 45.4-22.8 45.4a15 15 0 01-2.1-.2c-5.3-1.1-10.2-6.4-13.8-14.4a85.3 85.3 0 01-6.7-28v-.5c-.3-3.2-.4-6.6-.4-10a95 95 0 017.5-39.2c3.5-7.4 8-12.3 13-13.6a12.7 12.7 0 012.6-.4c12.8 0 23.1 23.8 23.1 53.2l-.2 3.2z"
				data-name="Pfad 55"
			/>
			<path
				d="M472.8 298.5a7.5 7.5 0 00-2.6.4c-5 1.3-9.5 6.2-13 13.6a95 95 0 00-7.5 39.2c0 3.4.1 6.8.4 10v.5c1 10.9 3.3 20.6 6.7 28 3.7 8 8.5 13.3 13.8 14.4a15 15 0 002.1.2c11.6 0 21.2-19.7 22.8-45.4l.1-2.4.1-2.1v-3.3c.2-29.2-10.2-53.1-22.9-53.1zm2.9 5.7c6.7 1.9 12.4 11.5 15.5 24.9l-16.7 12.6a12.1 12.1 0 00-2-3.6zm-17 14.1c2.9-7 6.6-11.9 10.9-13.7l-3.1 33.2a12.9 12.9 0 00-2.1 3.7l-2.5-1.9-7.5-5.8a79 79 0 014.3-15.5zm11.3 33.4c0 4-1.4 7.3-3.2 7.3-.9 0-1.7-.9-2.3-2.3a13.8 13.8 0 01-.9-4.5v-.6c0-4.1 1.4-7.3 3.2-7.3s3.2 3.4 3.2 7.4zm-16.6 10v-.4a99.2 99.2 0 01-.2-16.6l9.1 6.7.4.3v.1a32.4 32.4 0 001 8l.1.5a.4.4 0 00.1.3l-.1.6-4.5 25.4a16.7 16.7 0 01-.8-2 85 85 0 01-5.1-22.9zm19.9 37.9a7.5 7.5 0 01-2.6-.4c-2.7-.8-5.2-2.9-7.5-5.9l5-26.4a2.5 2.5 0 001.2.2 4.3 4.3 0 001.1-.2 3.8 3.8 0 001.8-1.3l13.9 23.1c-3.5 6.8-8 10.9-12.9 10.9zm20.2-44.2a9.2 9.2 0 01-.1 1.6 21.1 21.1 0 01-.2 2.6 92.4 92.4 0 01-4 21.6l-12.4-20.8-1.2-1.9-.2-.4a31.3 31.3 0 00.6-6.3v-.7l16.7-12.7a115 115 0 01.8 13.4 21.6 21.6 0 010 3.6z"
				data-name="Pfad 56"
				opacity=".8"
			/>
			<path
				d="M470 351.7c0 4-1.4 7.3-3.2 7.3-.9 0-1.7-.9-2.3-2.3a13.8 13.8 0 01-.9-4.5v-.6c0-4.1 1.4-7.3 3.2-7.3s3.2 3.4 3.2 7.4z"
				data-name="Pfad 57"
			/>
			<path
				d="M463.9 360.5l-.1.6-4.5 25.4a16.7 16.7 0 01-.8-2 78.5 78.5 0 01-5-22.7v-.4a99.2 99.2 0 01-.2-16.6l9.1 6.7.4.3v.1a32.4 32.4 0 001 8l.1.5v.1z"
				data-name="Pfad 58"
			/>
			<path
				d="M486.2 388.7c-3.5 6.8-8 10.9-12.9 10.9a7.5 7.5 0 01-2.6-.4c-2.7-.8-5.2-2.9-7.5-5.9l5-26.4a2.5 2.5 0 001.2.2 4.3 4.3 0 001.1-.2 3.8 3.8 0 001.8-1.3z"
				data-name="Pfad 59"
			/>
			<path
				d="M493.6 351.7l-.1 3.7a9.2 9.2 0 01-.1 1.6 21.1 21.1 0 01-.2 2.6 92.4 92.4 0 01-4 21.6l-12.4-20.8-1.2-1.9-.2-.4a31.3 31.3 0 00.6-6.3v-.7l16.7-12.7a93.7 93.7 0 01.9 13.3z"
				data-name="Pfad 60"
			/>
			<path
				d="M491.2 329.1l-16.7 12.6a12.1 12.1 0 00-2-3.6l3.2-33.9c6.7 1.9 12.4 11.5 15.5 24.9z"
				data-name="Pfad 61"
			/>
			<path
				d="M469.6 304.6l-3.1 33.2a12.9 12.9 0 00-2.1 3.7l-2.5-1.9-7.5-5.8a76.3 76.3 0 014.3-15.6c2.9-6.8 6.7-11.7 10.9-13.6z"
				data-name="Pfad 62"
			/>
			<path
				d="M654.7 194.5c-3.4-2.4-18.1-2.8-26.1-2.9a3.8 3.8 0 00-2.9 1.5 3.3 3.3 0 00-.3 3.2l6.1 15-1.2 1.1-2.4 2.1-.1.1-2 1.6-3.1 2.4c1.4 3.7 5.7 2.7 5.7 2.7l1.8-2 .8-.8 2.2-2.3 2.7-2.9a4.2 4.2 0 00.7-.1h.2l.9-.1 1-.2.6-.1.6-.1.6-.1 1.8-.3 4.1-.8a4.3 4.3 0 011.1-.2l2.5-.6 1.1-.3 1.6-.4h.2l1.4-.4 1.6-.5a1.9 1.9 0 01.7-.2 15.6 15.6 0 004.1-2c5.2-4.4-2.6-10-6-12.4zm.4 12.5a306.6 306.6 0 01-21.9 3.7l-6.6-14.8a2.4 2.4 0 01.2-2.3 2.3 2.3 0 012-1.1c7 0 22 .5 26.3 3.5 5.6 4 8.8 9.1 0 11z"
				data-name="Pfad 63"
				opacity=".8"
			/>
			<path
				d="M655.1 207a306.6 306.6 0 01-21.9 3.7l-6.6-14.8a2.4 2.4 0 01.2-2.3 2.3 2.3 0 012-1.1c7 0 22 .5 26.3 3.5 5.6 4 8.8 9.1 0 11z"
				data-name="Pfad 64"
			/>
			<path d="M356.2 157.1h-.7l.3-.3z" data-name="Pfad 65" />
		</g>
		<path
			id="rear-right-placeholder-original"
			fill="#fff"
			d="M260.6 210.6l-3.7 24.3h-88l4.8-22.7z"
		/>
		<path
			id="rear-right-placeholder-original"
			fill="currentColor"
			d="M260.6 210.6l-3.7 24.3h-88l4.8-22.7z"
			opacity=".2"
		/>
	</svg>
);
